export class SmartphotoFile {
    name;
    url;
    size;
    uploadedAt;
    path;
    constructor(name, url, size, uploadedAt, path) {
        this.name = name;
        this.url = url;
        this.size = size;
        this.uploadedAt = uploadedAt;
        this.path = path;
    }
    static fromApi(file) {
        const filename = [file.name, file.ext].join('.');
        return new SmartphotoFile(filename, file.url ?? '', file.size, file.uploadTime, file.path);
    }
    toApi() {
        const filenameParts = this.name.split('.');
        const extension = filenameParts.pop() ?? '';
        return {
            name: filenameParts.join('.'),
            ext: extension,
            size: this.size,
            uploadTime: this.uploadedAt ?? new Date().getTime(),
            path: this.path
        };
    }
}
